/**
 * Brand and site constants — centralized for consumer reuse.
 * Style tokens live in src/styles/globals.css under @theme.
 *
 * NOTE: The contact details below (domain, emails, phone) use the ARCOLL TECH
 * placeholder domain `arcolltech.com.br`. These MUST be confirmed with the
 * client before production deployment.
 */

export const BRAND = {
  name: 'ARCOLL TECH',
  longName: 'ARAUCÁRIA COLLECTION TECH',
  legalName: 'Araucaria Collection Tech LTDA',
  tagline: 'Conciliação de dívidas com tecnologia e atendimento humanizado',
  cnpj: '62.377.368/0001-20',
} as const;

export const CONTACT = {
  phone: '+55 (41) 3017-9870',
  phoneE164: '+554130179870',
  whatsapp: '0800 600 0406',
  whatsappLink: 'https://wa.me/554120180992',
  email: 'contato@arcolltech.com.br',
  dpoEmail: 'dpo@arcolltech.com.br',
  address: {
    street: 'Rua Mariano Torres, 729',
    complement: '4º andar e 7º andar',
    city: 'Curitiba',
    state: 'PR',
    zip: '80060-120',
  },
  recruitment: 'https://arcolltech.rhgestor.com.br',
} as const;

export const SITE = {
  url: import.meta.env.VITE_SITE_URL || 'https://arcolltech.com.br',
  locale: 'pt-BR',
  defaultTitle: 'ARCOLL TECH — Conciliação de Dívidas',
  titleTemplate: '%s · ARCOLL TECH',
} as const;

export const SOCIAL = {
  facebook: 'https://www.facebook.com/arcolltech',
  linkedin: 'https://www.linkedin.com/company/arcolltech',
  instagram: 'https://www.instagram.com/arcolltech',
} as const;

/** Used by color-blind / screen-reader testing and Tailwind arbitrary fallbacks */
export const BRAND_COLORS = {
  purple: '#3E2548',
  yellow: '#FBB040',
  darkgray: '#C0C0C0',
  lightgray: '#D9D9D9',
  bg: '#FFFFFF',
} as const;
